import classnames from "classnames";
import React from "react";

import BlinkingOnClickComponent from "../BlinkingOnClickComponent/BlinkingOnClickComponent";
import { KeyboardButton } from "../Keyboard";

// tslint:disable-next-line:no-var-requires
const style = require("./PinPadKeyboardLayout.scss");

function renderButton(char: string) {
    return (
        <BlinkingOnClickComponent activeClassName={style.active}>
            <KeyboardButton button={{ char }}>{char}</KeyboardButton>
        </BlinkingOnClickComponent>
    );
}

export function PinPadKeyboardLayout() {
    return (
        <div className={classnames(style.pinKeyboard)}>
            <div>
                {renderButton("1")}
                {renderButton("2")}
                {renderButton("3")}
            </div>
            <div>
                {renderButton("4")}
                {renderButton("5")}
                {renderButton("6")}
            </div>
            <div>
                {renderButton("7")}
                {renderButton("8")}
                {renderButton("9")}
            </div>
            <div className={classnames(style.pinWildcardRow)}>
                {renderButton("0")}
                <BlinkingOnClickComponent activeClassName={style.active}>
                    <KeyboardButton button={{ char: "\b" }}>C</KeyboardButton>
                </BlinkingOnClickComponent>
            </div>
        </div>
    );
}
